import {
  Component,
  OnInit,
  Input,
  OnChanges,
  HostListener,
} from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Router, ActivatedRoute } from "@angular/router";
import { NavMenuComponent } from "../nav-menu/nav-menu.component";
import { WriteUsComponent } from "../../components/pop-ups/write-us/write-us.component";
import { CallBackComponent } from "../../components/pop-ups/call-back/call-back.component";
import { LocateUsComponent } from "../../components/pop-ups/locate-us/locate-us.component";
import { TollFreeNotificationComponent } from "../../components/pop-ups/toll-free-notification/toll-free-notification.component";
import { CommonDataService } from "../../shared/services/common-data.service";
import { ApiService } from "../../shared/services/api.service";
import { Urls } from "../../utils/urls";
import { HeaderService } from './header.service';
import { response } from "express";
import { environment } from '../../../environments/environment.prod'
import { RedirectionService } from "@root/shared/services/redirection.service";


@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit, OnChanges {
  @Input() breadCrumbs: any;
  data: any;

  pageUrl!: string;

  headerData = {
    topMenus: [
      {
        displayName: "Products",
        url: "products",
        val: "products",
      },
      {
        displayName: "NAV & IDCW",
        url: "nav-dividends",
        val: "nav-dividends",
      },
      // {
      //   displayName: "NFO",
      //   url: "nfo",
      //   val: "nfo",
      // },
      {
        displayName: "Investors",
        url: "investors",
        val: "investors",
      },
      {
        displayName: "Partners",
        url: "distributor",
        val: "distributor",
      },
      {
        displayName: "CIO's Desk",
        url: "cio-desk",
        val: "cio-desk",
      },
      {
        displayName: "Forms & Downloads",
        url: "downloads",
        val: "downloads",
      },
      {
        displayName: "Investor Education",
        url: "blogs",
        val: "blogs",
      },
    ],
  };

  activeTab = "";

  subscription: any;

  latestNav: any = [];

  banners: any[] = [];

  // Getter to return only banners with valid filePath
  get validBanners(): any[] {
    return this.banners.filter(banner => banner && banner.filePath);
  }

  subBreadCrumb: any;

  bannerObj: any;

  public isSocialShare = false;
  showInvestOnlineBtn: boolean = true;

  customOptions: any;

  currentIndex: number = 0;

  previousIndex: number = 0;
  autoSlideInterval: any;

  constructor(
    private modalService: NgbModal,
    private router: Router,
    public commonDataService: CommonDataService,
    public apiService: ApiService,
    public activatedRoute: ActivatedRoute,
    private headerService: HeaderService, private redirectionService : RedirectionService) {

    this.commonDataService.dataSourceSub.asObservable().subscribe((data) => {
      this.subBreadCrumb = data;
    });
  }

  ngOnChanges() {
    this.data = this.breadCrumbs;
    if (this.data.hasCarousel) {
      this.autoSlide();
    }
    this.pageUrl = this.data.url
    if (
      this.data.url === "products" ||
      this.data.url === "nav-dividends" ||
      this.data.url === "downloads" ||
      this.data.url === "viewblogs"
    ) {
      this.activeTab = this.data.url;
    } else {
      this.activeTab = "";
    }

    if(this.data.url === 'blogs/view' || this.data.url ==='blogs/view-all'){
     this.showInvestOnlineBtn = false;
    }else{
      this.showInvestOnlineBtn = true;
    }

    this.setCarousel();
  }

  ngOnInit() {
    this.headerService.isSocialShareChange.subscribe(status => {
      this.isSocialShare = status;
    });
    this.getLatestNav();
    if (this.data.hasCarousel) {
      // this.autoSlide();
    }
    this.checkAndShowTollFreeNotification();
  }


   // Method to automatically slide the carousel every 5 seconds
   autoSlide(): void {
    this.autoSlideInterval = setInterval(() => {
      if(this.previousIndex === this.validBanners.length -1 && this.currentIndex ===0){
        clearInterval(this.autoSlideInterval);
        return;
      }
      this.previousIndex = this.currentIndex;
      this.currentIndex = (this.currentIndex + 1) % this.validBanners.length;
      this.updateCarousel();
    }, 5000);
  }

  scrollTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  phoneTo(mobile: any) {
    window.open(`tel:${mobile}`, "_system");
  }

  mailTo(email: any) {
    window.open(`mailto:${email}`, "_system");
  }

  getLatestNav = () => {
    this.apiService.getData(Urls.getLatestNav).subscribe((response: any) => {
      this.latestNav = response.data ? response.data.returnList : null;
    });
  };

  private setCarousel() {
    if (this.data.hasCarousel) {
      const pageContext = this.data.url;
      const source = window.innerWidth <= 768 ? "M" : "";
      switch (pageContext) {
        case "nfo":
          this.setNFOPageBanner(source);
          break;
        case "cio-desk":
        case "cio-desk-beta":
          this.setCEOPageBanner(source);
          break;
        case "iti-long-term-equity-fund":
          this.setLTEFPageBanner(source);
          break;
        default:
          this.setHomePageBanner(source);
      }
    }
  }

  private setHomePageBanner(source: string) {
    const obj = {
      source,
      bannerType: "Banners for Product",
    };
    this.apiService.postData(Urls.getBanners, obj).subscribe(
      response => {
        if (response.status === 0) {
          //  response = {"status":0,"message":"Success","data":{"referenceNo":"00370486","banners":[{"filePath":"https://dev.itiamc.com:8485/jeeth/api/v1/push/image/Long Term Equity Fund Banner_20201209180718712.jpg","id":51,"startDate":"12/09/2020 18:07:19.000000","endDate":"12/09/2020 18:07:19.000000","isActive":true,"name":"Long Term Equity Fund Banner","isWebBanner":false,"clickableUrl":"null","schemeCode":"EL","schemeName":"ITI ELSS Tax Saver Fund","bannerType":"Banners for Product"},{"filePath":"https://dev.itiamc.com:8485/jeeth/api/v1/push/image/01 For Distributor 2_20210101200719405.jpg","id":56,"startDate":"01/01/2021 20:07:22.000000","endDate":"01/01/2021 20:07:22.000000","isActive":true,"name":"01 For Distributor 2","isWebBanner":false,"clickableUrl":"null","schemeCode":"MC","schemeName":"ITI Multi Cap Fund","bannerType":"Banners for Product"},{"filePath":"https://dev.itiamc.com:8485/jeeth/api/v1/push/image/coloureddisclaimer1_20201130210735927_20211117120133529.jpeg","id":73,"startDate":"11/17/2021 12:01:34.000000","endDate":"11/17/2021 12:01:34.000000","isActive":true,"name":"coloureddisclaimer1","isWebBanner":false,"clickableUrl":"null","schemeCode":"BS","schemeName":"ITI Banking & PSU Debt Fund","bannerType":"Banners for Product"},{"filePath":"https://dev.itiamc.com:8485/jeeth/api/v1/push/image/singlecoin_20220810100220350.jpg","id":86,"startDate":"08/10/2022 10:02:20.000000","endDate":"08/10/2022 10:02:20.000000","isActive":true,"name":"singlecoin","isWebBanner":false,"clickableUrl":"null","schemeCode":"OF","schemeName":"ITI Overnight Fund","bannerType":"Banners for Product"},{"filePath":"https://dev.itiamc.com:8485/jeeth/api/v1/push/image/IMAGE5_20220810100417441.jpg","id":87,"startDate":"08/10/2022 10:04:18.000000","endDate":"08/10/2022 10:04:18.000000","isActive":true,"name":"IMAGE5","isWebBanner":false,"clickableUrl":"null","schemeCode":"DB","schemeName":"ITI Dynamic Bond Fund","bannerType":"Banners for Product"},{"filePath":"https://dev.itiamc.com:8485/jeeth/api/v1/push/image/images_20220818095153666.jpg","id":89,"startDate":"08/18/2022 09:51:53.000000","endDate":"08/18/2022 09:51:53.000000","isActive":true,"name":"images","isWebBanner":false,"clickableUrl":"null","schemeCode":"DB","schemeName":"ITI Dynamic Bond Fund","bannerType":"Banners for Product"},{"filePath":"https://dev.itiamc.com:8485/jeeth/api/v1/push/image/images_20220818095242696.jpg","id":90,"startDate":"08/18/2022 09:52:42.000000","endDate":"08/18/2022 09:52:42.000000","isActive":true,"name":"images","isWebBanner":false,"clickableUrl":"null","schemeCode":"OF","schemeName":"ITI Overnight Fund","bannerType":"Banners for Product"},{"filePath":"https://dev.itiamc.com:8485/jeeth/api/v1/push/image/images (1)_20220818095312413.jpg","id":91,"startDate":"08/18/2022 09:53:12.000000","endDate":"08/18/2022 09:53:12.000000","isActive":true,"name":"images (1)","isWebBanner":false,"clickableUrl":"null","schemeCode":"US","schemeName":"ITI Ultra Short Duration Fund","bannerType":"Banners for Product"},{"filePath":"https://dev.itiamc.com:8485/jeeth/api/v1/push/image/Vigilance-Awareness-Week-2023-Banner_20231102124645304.jpg","id":103,"startDate":"11/02/2023 12:46:46.000000","endDate":"11/02/2023 12:46:46.000000","isActive":true,"name":"Vigilance-Awareness-Week-2023-Banner","isWebBanner":false,"clickableUrl":"https://pledge.cvc.nic.in/","schemeCode":"null","schemeName":null,"bannerType":"Banners for Product"},{"filePath":"https://dev.itiamc.com:8485/jeeth/api/v1/push/image/download (1)_20240727200814854.jfif","id":106,"startDate":"07/27/2024 20:08:14.000000","endDate":"07/27/2024 20:08:14.000000","isActive":true,"name":"download (1)","isWebBanner":false,"clickableUrl":"null","schemeCode":"BS","schemeName":"ITI Banking & PSU Debt Fund","bannerType":"Banners for Product"},{"filePath":"https://dev.itiamc.com:8485/jeeth/api/v1/push/image/ITI-Large-&-Mid-Cap-Fund-Home-Page-Banner_20240810121823693_20240820234156991.jpg","id":111,"startDate":"08/20/2024 23:41:57.000000","endDate":"08/20/2024 23:41:57.000000","isActive":true,"name":"ITI-Large-&-Mid-Cap-Fund-Home-Page-Banner","isWebBanner":false,"clickableUrl":"null","schemeCode":"LM","schemeName":"ITI Large & Mid Cap Fund","bannerType":"Banners for Product"}]}}
          this.banners = response.data.banners || [];
        } else {
          this.banners = [];
        }
        this.getLatestNav();
      },
      error => {
        this.banners = [];
      }
    )
  }

  private setNFOPageBanner(source: string) {
    const obj = {
      source,
      bannerType: "Banners for NFO",
    };
    this.apiService.postData(Urls.getBanners, obj).subscribe(
      response => {
        if (response.status === 0) {
          this.banners = response.data.banners || [];
        } else {
          this.banners = [];
        }
        this.getLatestNav();
      },
      error => {
        this.banners = [];
      }
    )

  }

  private setCEOPageBanner(source: string) {
    const obj = {
      source,
      bannerType: "Banners for CEO",
    };
    this.apiService.postData(Urls.getBanners, obj).subscribe(
      response => {
        if (response.status === 0) {
          
          this.banners = response.data.banners || [];
        } else {
          this.banners = [];
        }
        this.getLatestNav();
      },
      error => {
        this.banners = [];
      }
    )

  }

  private setLTEFPageBanner(source: string) {
    const obj = {
      source,
      bannerType: "Banners for LTEF",
    };
    this.apiService.postData(Urls.getBanners, obj).subscribe(
      response => {
        if (response.status === 0) {
          this.banners = response.data.banners || [];
        } else {
          this.banners = [];
        }
        this.getLatestNav();
      },
      error => {
        this.banners = [];
      }
    )

  }

  openNav = () => {
    if (window.innerWidth < 760) {
      this.modalService.open(NavMenuComponent, {
        windowClass: "align-modal-menu-mobile",
      });
    } else {
      this.modalService.open(NavMenuComponent, {
        windowClass: "align-modal-menu",
      });
    }
  };

  openPopUp = (val: string) => {
    if (val === "callback") {
      this.modalService.open(CallBackComponent, {
        size: "lg",
        windowClass: "align-modal-center",
      });
    } else if (val === "write") {
      this.modalService.open(WriteUsComponent, {
        size: "lg",
        windowClass: "align-modal-center",
      });
    } else {
      this.modalService.open(LocateUsComponent, {
        size: "lg",
        windowClass: "align-modal-center",
      });
    }
  };

  openPopUpMobile = (val: string) => {
    const width = window.innerWidth;
    if (width <= 768) {
      this.navFooterLink(val);
    } else {
      if (val === "call-back") {
        this.modalService.open(CallBackComponent, {
          size: "lg",
          windowClass: "align-modal-center",
        });
      } else if (val === "write-to-us") {
        this.modalService.open(WriteUsComponent, {
          size: "lg",
          windowClass: "align-modal-center",
        });
      } else if (val === "locate-us") {
        this.modalService.open(LocateUsComponent, {
          size: "lg",
          windowClass: "align-modal-center",
        });
      } else {
        this.navFooterLink(val);
      }
    }
  };

  navFooterLink = (link: string) => {
    this.router.navigate([link]);
  };


  investOnline = () => {

    this.redirectionService.redirectToInvestorPortal();

    // if (!environment.isDRBuild) {
    //   // window.open("https://investonline.itiamc.com/", "_blank");
    //   if (environment.baseurl === 'https://dev.itiamc.com:8485/jeeth/api/v1/catalog/') {
    //     window.open("https://dev.itiamc.com:8486/", "_blank");
    //   }
    //   else if (environment.baseurl === "https://itiamc.com/jeeth/api/v1/catalog/") {
    //     window.open("https://investonline.itiamc.com/", "_blank");
    //   }
    //   else {
    //     window.open("https://investonline.itiamc.com/", "_blank");
    //   }
    // } else {
    //   window.open("https://investonline.itiamc.com/", "_blank"); //DR-inv
    // }
  };

  navPage = (url: any, val: string) => {
    this.router.navigate([url]);
    this.activeTab = val;
  };

  navFromBreadCrumb = (url: any) => {
    this.router.navigate([url]);
  };

  homeNav = () => {
    this.router.navigate(["/"]);
    this.scrollTop();
  };

  public viewDetails(banner:any){
    if(banner.schemeName){
      const url = banner.schemeName.replace(/\s/g, "-");
      this.router.navigateByUrl("products/" + url.toLowerCase());
    }else if(banner.clickableUrl && banner.clickableUrl.length >0 && banner.clickableUrl!=='null'){

      const isRelativePath = banner.clickableUrl.indexOf('http')===-1;
      isRelativePath ? this.router.navigateByUrl(banner.clickableUrl) :  window.open(banner.clickableUrl, "_blank");
    
    }
  }

  selectSlide(index: number): void {
    if (index !== this.currentIndex) {
      this.previousIndex = this.currentIndex;
      this.currentIndex = index;
      this.updateCarousel();
    }
  }
  updateCarousel(): void {
    // Determine which carousel to update based on screen size
    const isMobile = window.innerWidth <= 768;
    const carouselId = isMobile ? '#myCarouselMobile' : '#myCarousel';
    
    const slides = document.querySelectorAll(`${carouselId} .carousel-item`);
    slides.forEach((slide, index) => {
      slide.classList.remove('active', 'slide-in', 'slide-out');

      if (index === this.currentIndex) {
        slide.classList.add('active', 'slide-in');
      } else if (index === this.previousIndex) {
        slide.classList.add('slide-out');
      }
    });

    const indicators = document.querySelectorAll(`${carouselId} .carousel-indicators li`);
    indicators.forEach((indicator, index) => {
      indicator.classList.remove('active'); // Reset all indicators
      if (index === this.currentIndex) {
        indicator.classList.add('active'); // Set the current index as active
      }
    });
  }

    backToMain(){
    this.router.navigate(['/blogs'])
  }

  checkAndShowTollFreeNotification() {
    const now = new Date();
    // Enable from 01 Feb 2026, 12:00 AM to 03 Feb 2026, 11:59 PM
    const startDate = new Date(2026, 1, 1, 0, 0, 0);   // 01 Feb 2026, 12:00 AM (month is 0-indexed)
    const endDate = new Date(2026, 1, 3, 23, 59, 0);   // 03 Feb 2026, 11:59 PM

    // Check if the current time falls within the notification period
    if (now >= startDate && now <= endDate) {
      // Check if the notification has already been shown in this session
      // const hasSeenNotification = sessionStorage.getItem('tollFreeNotificationShown');
      
      // if (!hasSeenNotification) {
        // Show the notification popup after a short delay
        setTimeout(() => {
          const modalRef = this.modalService.open(TollFreeNotificationComponent, {
            backdrop: 'static',
            keyboard: false,
            windowClass: 'toll-free-notification-modal-wrapper'
          });

          // Mark as shown in session storage
          // modalRef.result.then(
          //   () => {
          //     sessionStorage.setItem('tollFreeNotificationShown', 'true');
          //   },
          //   () => {
          //     sessionStorage.setItem('tollFreeNotificationShown', 'true');
          //   }
          // );
        }, 1000); // Show after 1 second delay
      // }
    }
  }

  navigateToSIF(){
    window.open("https://sif.itiamc.com/.", "_blank");
  }

}
